import { useEffect, useState } from "react";

const TZ = "America/Toronto";

function msUntilMidnight(timeZone = TZ) {
  const now = new Date();
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
  }).formatToParts(now);

  const hour = Number(parts.find((p) => p.type === "hour")?.value || 0);
  const minute = Number(parts.find((p) => p.type === "minute")?.value || 0);
  const second = Number(parts.find((p) => p.type === "second")?.value || 0);

  const elapsedMs = ((hour * 60 + minute) * 60 + second) * 1000;
  return 86400000 - elapsedMs;
}

export function formatCountdownParts(ms) {
  const safe = Math.max(0, ms);
  const h = Math.floor(safe / 3600000);
  const m = Math.floor((safe % 3600000) / 60000);
  const s = Math.floor((safe % 60000) / 1000);
  return { h, m, s };
}

export function formatCountdownInline(ms) {
  const { h, m, s } = formatCountdownParts(ms);
  return `${h}h ${String(m).padStart(2, "0")}m ${String(s).padStart(2, "0")}s`;
}

export function formatCountdownClock(ms) {
  const { h, m, s } = formatCountdownParts(ms);
  return {
    h: String(h).padStart(2, "0"),
    m: String(m).padStart(2, "0"),
    s: String(s).padStart(2, "0"),
  };
}

/** Live countdown to midnight in America/Toronto (platform featured rotation). */
export default function useMidnightCountdown(timeZone = TZ) {
  const [remainingMs, setRemainingMs] = useState(() => msUntilMidnight(timeZone));

  useEffect(() => {
    const tick = () => setRemainingMs(msUntilMidnight(timeZone));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [timeZone]);

  return remainingMs;
}
